import {BottomItem} from '@appStore/reducers/leftSideMenu.ts'
import {useLocation} from 'react-router-dom'

import {Item} from '../components/Item'

interface AccountMenuProps {
	leftSide: {
		bottomList: BottomItem[]
	}
}

export function AccountMenu({leftSide}: AccountMenuProps) {
	const {pathname} = useLocation()
	if (!leftSide.bottomList?.length) {
		return null
	}

	return (
		<>
			{leftSide.bottomList.map(item => {
				const isActive = pathname === item.link || pathname.startsWith(item.link + '/')
				return (
					<Item
						{...item}
						isActive={isActive}
						key={item.id}
					/>
				)
			})}
		</>
	)
}
